export default {
      id: "questionIcon-usage",
      viewBox: "0 0 11 11",
      url: __webpack_public_path__ + "img/icons.cd84ca0f.svg#questionIcon",
      toString: function () {
        return this.url;
      }
    }